webpackJsonp([43000224873248],{

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bureau-cabinet-psychologue-montpellier-1.f897aec8.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bureau-cabinet-psychologue-montpellier.4c141736.jpg";

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	__webpack_require__(333);
	
	var _bureauCabinetPsychologueMontpellier = __webpack_require__(438);
	
	var _bureauCabinetPsychologueMontpellier2 = _interopRequireDefault(_bureauCabinetPsychologueMontpellier);
	
	var _bureauCabinetPsychologueMontpellier3 = __webpack_require__(437);
	
	var _bureauCabinetPsychologueMontpellier4 = _interopRequireDefault(_bureauCabinetPsychologueMontpellier3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Cabinet Psychologue à Montpellier | Psychologue clinicienne à Montpellier quartier les arceaux  | Morgane Laroche',
	  description: 'Je reçois les adultes en entretien individuels sur rendez-vous sur rendez-vous, du Lundi au Jeudi. Les consultations ont lieu dans mon cabinet situé au 300 Rue Auguste Broussonnet à Montepllier, à deux pas de l’arrêt de tram Place Albert 1er – Saint Charles.'
	};
	var GaleriePage = function GaleriePage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container__galery' },
	        _react2.default.createElement(
	          'div',
	          { className: 'galery__office' },
	          _react2.default.createElement('img', {
	            src: _bureauCabinetPsychologueMontpellier2.default,
	            alt: 'mon cabinet psy \xE0 montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne quartier les arceaux, psychologue montpellier, psy montpellier'
	          }),
	          _react2.default.createElement('img', {
	            src: _bureauCabinetPsychologueMontpellier4.default,
	            alt: 'bureau psy \xE0 montpellier, bureau psychologue \xE0 montpellier, montpellier psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne \xE0 Montpellier, cabinet de psychologie \xE0 Montpellier, psychologue montpellier, psy montpellier'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = GaleriePage;
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-galerie-js-e3cdd8eabc7f3aa81ee2.js